import axios from 'axios';

export default function getUserLocations(config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': 'unknown'
  };
  const url = `${config.getUserLocations}`;
  return dispatch => dispatch({
    type: 'USER_LOCATIONS_FETCH',
    payload: axios({ method: 'get', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}


// WEBPACK FOOTER //
// ./src/actions/getUserLocations.js